module.exports = __webpack_public_path__ + "static/media/defaultAvatar.104c62fa.svg";